import { ErrorPage, NotFoundPage } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router';

import { App } from './App';
import { AccessDeniedPage } from './components/containers/AccessDeniedPage';
import { ActivityReportPage } from './components/containers/ActivityReportPage';
import { ArrearsArrangementPage } from './components/containers/ArrearsArrangementPage';
import { AuthRegistrationPage } from './components/containers/AuthRegistrationPage';
import { CaseCreatePage, CasePage } from './components/containers/CasePage';
import { HousingApplicationPage } from './components/containers/HousingApplicationPage';
import { LoginPage, LoginWithPinPage } from './components/containers/LoginPage';
import { ManagementToolsPage } from './components/containers/ManagementToolsPage';
import { NotePage } from './components/containers/NotePage';
import { NoteCreatePage } from './components/containers/NotePage/NoteCreatePage';
import { PcfraCreateEditPage } from './components/containers/PcfraCreateEditPage';
import { PcfraPropertyPage } from './components/containers/PcfraPropertyPage';
import { PersonPage, PersonEditPage } from './components/containers/PersonPage';
import { ContactDetailsEditPage } from './components/containers/PersonPage/ContactDetailsEditPage';
import { HouseholdMemberCreatePage } from './components/containers/PersonPage/HouseholdMemberCreatePage';
import { PropertyPage } from './components/containers/PropertyPage/PropertyPage';
import { PropertySelectPage } from './components/containers/PropertySelectPage';
import {
  PropertyVisitCreatePage,
  PropertyVisitEditPage,
  PropertyVisitPage,
} from './components/containers/PropertyVisitPage';
import { ResidentsReportPage } from './components/containers/ResidentsReportPage';
import { ServiceRequestPage } from './components/containers/ServiceRequestPage/ServiceRequestPage';
import { UserPinRegistrationPage } from './components/containers/UserPinRegistrationPage';
import { webAuthnEnabled } from './config/appConfig';
import { routes } from './config/routes';

export const AppRouter: FunctionComponent = () => (
  <Router>
    <Routes>
      <Route path={routes.home} element={<App />} errorElement={<ErrorPage />}>
        <Route index element={<PropertySelectPage />} />
        <Route path={routes.property} element={<PropertyPage />} />
        <Route path={routes.person} element={<PersonPage />} />
        <Route path={routes.personEdit} element={<PersonEditPage />} />
        <Route path={routes.householdMemberCreate} element={<HouseholdMemberCreatePage />} />
        <Route path={routes.contactDetailsEdit} element={<ContactDetailsEditPage />} />
        <Route path={routes.case} element={<CasePage />} />
        <Route path={routes.caseCreate} element={<CaseCreatePage />} />
        <Route path={routes.note} element={<NotePage />} />
        <Route path={routes.noteCreate} element={<NoteCreatePage />} />
        <Route path={routes.visit} element={<PropertyVisitPage />} />
        <Route path={routes.visitCreate} element={<PropertyVisitCreatePage />} />
        <Route path={routes.visitEdit} element={<PropertyVisitEditPage />} />
        <Route path={routes.serviceRequest} element={<ServiceRequestPage />} />
        <Route path={routes.housingApplication} element={<HousingApplicationPage />} />
        <Route path={routes.arrearsArrangement} element={<ArrearsArrangementPage />} />

        <Route path={routes.pcfraProperty} element={<PcfraPropertyPage />} />
        <Route path={routes.pcfraCreate} element={<PcfraCreateEditPage />} />
        <Route path={routes.pcfraEdit} element={<PcfraCreateEditPage />} />

        <Route path={routes.residentsReport} element={<ResidentsReportPage />} />
        <Route path={routes.activityReport} element={<ActivityReportPage />} />

        <Route path={routes.managementTools} element={<ManagementToolsPage />} />

        <Route
          path={routes.login}
          element={webAuthnEnabled ? <LoginPage /> : <LoginWithPinPage />}
        />
        <Route
          path={routes.authRegistration}
          element={webAuthnEnabled ? <AuthRegistrationPage /> : <UserPinRegistrationPage />}
        />
        <Route path={routes.authFailed} element={<AccessDeniedPage />} />
        <Route path={routes.error} element={<ErrorPage />} />
        <Route path={routes.notFound} element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </Router>
);
